<template>
  <div class="dashboard-page">
    <!-- {{value}} -->
    <tumeng-editor
      ref="editor"
      :impot-flag.sync="impotFlag"
      :program-info.sync="value"
      :img-options.sync="imgOptions"
      :goods-fields.sync="goodsFields"
      :font-family-list.sync="fontFamilyList"
      :price-tag-options.sync="priceTagOptions"
      :video-options="videoOptions"
      :groupList="groupList"
      :pixelsList="pixelsList"
      :userFontList="userFontList"
      @img-list-change="reGetImageList"
      @img-current-change="handleImageCurrentChange"
      @img-size-change="handleImageSizeChange"
      @img-search-change="handleImageSearchChange"
      @img-init-change="handleImageInitChange"
      @price-tag-current-change="handlePriceTagCurrentChange"
      @price-tag-size-change="handlePriceTagSizeChange"
      @price-tag-search-change="handlePriceTagSearchChange"
      @video-current-change="handleVideoCurrentChange"
      @video-size-change="handleVideoSizeChange"
      @video-search-change="handleVideoSearchChange"
      @delete-component="handleDeleteComponent"
      @back="handleBack"
      @save="handleSave"
      @import="handImport"
      @export="handExport"
      @createImg="createImg"
    ></tumeng-editor>

    <ImportDialog ref="importDialog" @impotContent="impotContent" />
  </div>
</template>
<script>
import ImportDialog from "./importDialog";
import { getCodeList } from "@/libs/api/aps"; // 获取下拉列表list接口
import {
  getMaterialList,
  getPixels,
  scenarioFiledList,
  getTemplateList,
  getTemplateInfo,
  createInfo,
  updateInfo,
  copyInfo,
  activeInfo,
  unActiveInfo,
  saveJson,
  saveEslJson,
  getScenario,
  getEslTemplateInfo, // 获取ESL价签详情
  getEslImages, // 获取ESL素材列表
  getEslImageColorUrl, // 获取ESL素材详情url
} from "@/libs/api/lcd";
import { getFontList } from "@/libs/api/system-config-font";
export default {
  data() {
    return {
      // EditorConfig,
      // initValue: JSON.parse(localStorage.getItem("templateInfo")),
      clipboardContent: "",
      impotFlag: 0,
      value: {
        activeState: "",
        isAddMarketPostion: 0,
        itemQty: 4,
        openType: 3,
        templateGroup: 1,
        templateId: "",
        templateName: "",
        templateSize: "800*1280",
        width: 800,
        height: 1280,
        bgColor: "",
        bgImg: "",
        scale: 1,
        pages: [
          {
            id: "",
            title: "",
            componentList: [],
            imgId: null,
            bgImg: "",
            bgColor: "rgba(255,255,255,0)",
            customScript: "",
            duration: 10,
            groupNum: 1,
          },
        ],
        goodsFields: [],
        ...JSON.parse(localStorage.getItem("templateInfo")),
      },
      goodsFields: [],
      pagesPriceTag: [
        {
          id: 1,
          title: "Price1",
          componentList: [],
          imgId: null,
          bgImg: "",
          bgColor: "rgba(255,255,255,0)",
          customScript: "",
        },
        {
          id: 2,
          title: "Price2",
          componentList: [],
          imgId: null,
          bgImg: "",
          bgColor: "rgba(255,255,255,0)",
          customScript: "",
        },
        {
          id: 3,
          title: "Price3",
          componentList: [],
          imgId: null,
          bgImg: "",
          bgColor: "rgba(255,255,255,0)",
          customScript: "",
        },
        {
          id: 4,
          title: "Price4",
          componentList: [],
          imgId: null,
          bgImg: "",
          bgColor: "rgba(255,255,255,0)",
          customScript: "",
        },
        {
          id: 5,
          title: "Price5",
          componentList: [],
          imgId: null,
          bgImg: "",
          bgColor: "rgba(255,255,255,0)",
          customScript: "",
        },
      ],
      groupList: [],
      formatList: [],
      pixelsList: [],
      fontFamilyList: [],
      imgOptions: {
        imageList: [],
        groupId: "", // 素材分组
        materialName: "",
        pixels: "",
        materialType: "0",
        openType: "0,1,2,3,4",
        state: "1",
        current: 1,
        size: 10,
        total: 0,
        sizes: [10, 20, 50, 100, 500, 1000, 2000],
      },
      priceTagOptions: {
        priceTagList: [],
        templateName: "",
        templateSize: "",
        current: 1,
        size: 10,
        total: 0,
        sizes: [10, 20, 50, 100, 500, 1000, 2000],
      },
      videoOptions: {
        videoList: [],
        groupId: "", // 素材分组
        materialName: "",
        pixels: "",
        materialType: "1",
        openType: "0,1,2,3,4",
        state: "1",
        current: 1,
        size: 10,
        total: 0,
        sizes: [10, 20, 50, 100, 500, 1000, 2000],
      },
      // esl素材初始化配置
      eslImgOptions: {
        storeId: localStorage.getItem("storeId"),
        storeType: 0, // 所有门店
        current: 1,
        size: 10,
        total: 0,
        sizes: [10, 20, 50, 100, 500, 1000, 2000],
      },
      form: {
        name: "1品_价签",
        isTemplate: 0,
      },
      userData: localStorage.getItem("userData")
        ? JSON.parse(localStorage.getItem("userData"))
        : {},
      userFontList: [],
    };
  },
  components: {
    ImportDialog,
  },
  computed: {},
  watch: {},
  created() {
    // 获取用户权限字体
    // this.getUserFontList()
    // this.getInfo();
    this.getGoodsFields();

    console.log(this.value);
  },
  mounted() {
    this.getPixelList();
    this.getEnum(40);
    this.getEnum(41); // 是否用到待定
    this.getImageList();
    this.getVideoList();
    this.getPriceTagList();
    // console.log(EditorConfig);
  },
  beforeRouteEnter(to, from, next) {
    // 获取当前商户的个性化字体
    const fontParams = {
      storeId: localStorage.getItem("storeId"),
    };
    getFontList(fontParams).then((res) => {
      console.log("getFontList");
      console.log(res);
      console.log(res.data.data.records);
      const fontList = res.data.data.records;
      if (fontList.length > 0) {
        const userFontList = fontList.map((f) => {
          return f.fontName;
        });
        localStorage.setItem("userFontList", JSON.stringify(userFontList));
        console.log(localStorage.getItem("userFontList"));
      } else {
        localStorage.setItem("userFontList", JSON.stringify(""));
      }
    });

    localStorage.removeItem("templateInfo");
    console.log(to, from);
    console.log(to.query.templateId);
    // console.log(to.query.origin);
    console.log("to.query.origin==========>", to.query.origin);
    if (to.query.origin && to.query.origin == "esl") {
      // return
      let initEslValue = {
        isAddMarketPostion: 0,
        itemQty: 0,
        templateGroup: "3", // 3代表ESL
        templateId: "",
        templateName: "",
        templateSize: "",
        width: "",
        height: "",
        bgColor: "",
        bgImg: "",
        scale: 1,
        color: "",
        pages: [
          {
            id: 1,
            title: "ESL",
            componentList: [],
            imgId: null,
            bgImg: "",
            bgColor: "rgba(255,255,255,1)",
            customScript: "",
          },
        ],
        goodsFields: [],
      };

      getEslTemplateInfo({ templateId: to.query.templateId }).then((res) => {
        console.log("resinitEslValue==========>", res);
        const svgValue = res.data.data.templateSvgStyleEntity.svgValue;
        console.log("resinitEslValue==========>", res.data.data);
        if (!svgValue) {
          console.log("当前svgValue==========>", svgValue);
          initEslValue = {
            ...initEslValue,
            templateId: res.data.data.templateId,
            templateName: res.data.data.templateName,
            templateSize: res.data.data.templateSize,
            width: res.data.data.width,
            height: res.data.data.height,
            color: res.data.data.color,
          };
          console.log("当前svgValue==========>", res.data.data.templateId);
          console.log("当前svgValue==========>", res.data.data.templateName);
          console.log("当前svgValue==========>", res.data.data.templateSize);
          console.log("当前svgValue==========>", res.data.data.width);
          console.log("当前svgValue==========>", res.data.data.initValue);
        } else {
          initEslValue = {
            ...initEslValue,
            ...JSON.parse(svgValue),
            templateId: res.data.data.templateId,
            templateName: res.data.data.templateName,
            templateSize: res.data.data.templateSize,
            width: res.data.data.width,
            height: res.data.data.height,
            color: res.data.data.color,
          };
        }
        localStorage.setItem("templateInfo", JSON.stringify(initEslValue));
        next(() => {
          console.log(
            "======initEslValueshainitValue==========>",
            initEslValue
          );
        });
      });

      console.log(localStorage.getItem("currentEslTemplate"));
      return;
    }
    let initValue = {
      activeState: "",
      isAddMarketPostion: 0,
      itemQty: 0,
      openType: "",
      templateGroup: "",
      templateId: "",
      templateName: "",
      templateSize: "",
      width: "",
      height: "",
      bgColor: "",
      bgImg: "",
      scale: 1,
      pages: [
        {
          id: "",
          title: "",
          componentList: [],
          imgId: null,
          bgImg: "",
          bgColor: "rgba(255,255,255,0)",
          customScript: "",
          duration: 10,
          groupNum: 1,
        },
      ],
      goodsFields: [],
    };
    let pagesPop = [];
    const pagesPriceTag = [
      {
        id: 1,
        title: "Price1",
        componentList: [],
        imgId: null,
        bgImg: "",
        bgColor: "rgba(255,255,255,0)",
        customScript: "",
      },
      {
        id: 2,
        title: "Price2",
        componentList: [],
        imgId: null,
        bgImg: "",
        bgColor: "rgba(255,255,255,0)",
        customScript: "",
      },
      {
        id: 3,
        title: "Price3",
        componentList: [],
        imgId: null,
        bgImg: "",
        bgColor: "rgba(255,255,255,0)",
        customScript: "",
      },
      {
        id: 4,
        title: "Price4",
        componentList: [],
        imgId: null,
        bgImg: "",
        bgColor: "rgba(255,255,255,0)",
        customScript: "",
      },
      {
        id: 5,
        title: "Price5",
        componentList: [],
        imgId: null,
        bgImg: "",
        bgColor: "rgba(255,255,255,0)",
        customScript: "",
      },
    ];
    const params = {
      templateId: to.query.templateId,
    };
    let adSpace = [
      {
        title: "营销位",
        name: "营销位",
        type: "TumengAd",
        editType: "TumengAdEdit",
        icon: "icon-video",
        left: 0,
        top: 0,
        width: 800,
        height: 480,
        zIndex: 10,
        borderRadius: 0,
        hide: false,
        videoList: [],
        duration: 30,
        adList: [
          {
            url: "https://bowtz-lcd.oss-cn-hangzhou.aliyuncs.com/res/lcd/material/video/0/1/20240718/ce02483a9e4644af9bbe8569cdfb6993.mp4",
            videoId: null,
            duration: "10",
          },
        ],
        componentId: 1,
        groupId: 1,
        index: 0,
      },
    ];
    getTemplateInfo(params).then((res) => {
      // console.log("res.data.data", res.data.data);
      // console.log("res.data.data.svgValue", res.data.data.svgValue);
      // 兼容横屏模板营销位
      if (res.data.data.width == 1280) {
        adSpace[0].width = 480;
        adSpace[0].height = 800;
        adSpace[0].adList[0].url =
          "https://bowtz-lcd.oss-cn-hangzhou.aliyuncs.com/res/lcd/material/video/0/1/20240718/37d2897c58214bb7a5f2510f8c1f8cad.mp4";
        // console.log("res.data.data.svgValue.......adSpace", adSpace);
      }
      if (!res.data.data.svgValue) {
        console.log("=======》〉》〉》〉》〉》");
        for (let i = 0; i < res.data.data.itemQty + 1; i++) {
          pagesPop.push({
            id: i + 1,
            title: i == 0 ? "Unbind" : i + "Items",
            componentList:
              res.data.data.isAddMarketPostion == 1 && i > 0 && i < 3
                ? adSpace
                : [],
            imgId: null,
            bgImg: "",
            bgColor: "rgba(255,255,255,0)",
            customScript: "",
            duration: 10,
            groupNum: 1,
            itemNum: i,
          });
        }
        initValue = {
          ...res.data.data,
          pages: res.data.data.templateGroup == 0 ? pagesPriceTag : pagesPop,
        };
        // console.log("傻子", this.value);
      } else {
        initValue = {
          ...initValue,
          ...JSON.parse(res.data.data.svgValue),
          templateId: res.data.data.templateId,
          templateName: res.data.data.templateName,
          openType: res.data.data.openType,
        };
      }
      localStorage.setItem("templateInfo", JSON.stringify(initValue));
      next(() => {
        console.log("======sha>>>>>>>>", initValue);
      });
    });
  },
  beforeDestroy() {
    // 需要移除一些localstorage
    // remove("PROGRAM_INFO");
    // remove("PREVIOUS_ROUTE");
    // localStorage.removeItem("templateInfo");
  },
  methods: {
    // getInfo() {

    //   },
    //获取门店字体
    getUserFontList() {
      const params = {
        storeId: localStorage.getItem("storeId"),
      };
      getFontList(params).then((res) => {
        console.log("getFontList");
        console.log(res);
        console.log(res.data.data.records);
        const fontList = res.data.data.records;
        if (fontList.length > 0) {
          this.userFontList = fontList.map((f) => {
            return f.fontName;
          });
          console.log(this.userFontList);
        }
      });
    },
    reGetImageList(type) {
      let purposeType = "";
      switch (type) {
        case 0:
          purposeType = "tagskin";
          break;
        case 1:
          purposeType = "material";
          break;
        case 2:
          purposeType = "advert";
          break;
      }
      this.imgOptions.purpose = purposeType;
      this.getImageList();
    },
    // 获取图片列表
    getImageList() {
      this.imgOptions.imageList = [];
      if (this.$route.query.origin == "esl") {
        const { imageName, current, size, storeId } = this.eslImgOptions;
        const params = {
          imageName,
          current,
          size,
          storeType: 0,
          storeId,
        };
        getEslImages(params).then((res) => {
          console.log(res);
          this.imgOptions.imageList = res.data.data.records.map((it) => {
            it.url = it.originalUrl || it.decodedUrl || it.imageUrl;
            return it;
          });
          this.imgOptions.total = res.data.data.total;
        });
        return;
      }

      console.log(this.imgOptions);
      const {
        materialType,
        groupId,
        state,
        materialName,
        pixels,
        current,
        size,
      } = this.imgOptions;
      const params = {
        materialType,
        groupId,
        materialName,
        pixels,
        state,
        current,
        size,
      };
      getMaterialList(params).then((res) => {
        console.log(res);
        this.imgOptions.imageList = res.data.data.records.map((it) => {
          it.url = it.originalUrl || it.decodedUrl;
          return it;
        });
        this.imgOptions.total = res.data.data.total;
      });
    },
    handleImageSearchChange(val) {
      console.log("handleImageSearchChange====>图片列表搜索", val);
      this.imgOptions = {
        ...this.imgOptions,
        ...val,
      };
      this.eslImgOptions = {
        ...this.eslImgOptions,
        imageName: val.materialName,
      };
      this.getImageList();
    },
    handleImageCurrentChange(val) {
      console.log("handleImageCurrentChange====>图片列表翻页", val);
      this.imgOptions.current = val;
      this.eslImgOptions.current = val;
      this.getImageList();
    },
    handleImageInitChange(val) {
      console.log("handleImageInitChange====>图片列表搜索", val);
      this.imgOptions = {
        ...this.imgOptions,
        ...val,
        current: 1,
      };
      this.eslImgOptions = {
        ...this.eslImgOptions,
        imageName: val.materialName,
        current: 1,
      };
      this.getImageList();
    },
    handleImageSizeChange(val) {
      console.log("handleImageSizeChange====>图片列表size变更", val);
      this.imgOptions.current = 1;
      this.imgOptions.size = val;
      this.eslImgOptions.current = 1;
      this.eslImgOptions.size = val;

      this.getImageList();
    },

    // Video相关
    getVideoList() {
      // TODO获取价签列表
      console.log("获取视频列表");
      this.videoOptions.videoList = [];
      console.log(this.videoOptions);
      const { materialType, groupId, materialName, pixels, current, size } =
        this.videoOptions;
      const params = {
        materialType,
        groupId,
        materialName,
        pixels,
        current,
        size,
      };
      getMaterialList(params).then((res) => {
        console.log(res);
        this.videoOptions.videoList = res.data.data.records.map((it) => {
          it.url = it.originalUrl || it.decodedUrl;
          return it;
        });
        this.videoOptions.total = res.data.data.total;
      });
      return;
      vl({
        current: this.videoOptions.current,
        size: this.videoOptions.size,
        type: "media",
      }).then((res) => {
        this.videoOptions.videoList = res.data.map((it) => {
          it.url = process.env.VUE_APP_BASE_API + it.decodedUrl;
          return it;
        });
        this.videoOptions.total = res.total;
      });
    },
    handleVideoCurrentChange(val) {
      console.log("handleVideoCurrentChange", val);
      this.videoOptions.current = val;
      this.getVideoList();
    },
    handleVideoSizeChange(val) {
      console.log("handleVideoSizeChange", val);
      this.videoOptions.current = 1;
      this.videoOptions.size = val;
      this.getVideoList();
    },
    handleVideoSearchChange(val) {
      console.log("handleVideoSearchChange====>视频列表搜索", val);
      this.videoOptions = {
        ...this.videoOptions,
        ...val,
      };
      this.getVideoList();
    },

    // 价签相关
    // 获取0-4随机整数
    getRandomInt(min, max) {
      min = Math.ceil(min); // 确保min是整数
      max = Math.floor(max); // 确保max是整数
      return Math.floor(Math.random() * (max - min + 1)) + min; // 返回介于min和max之间的随机整数
    },
    getPriceTagList() {
      // TODO获取价签列表
      console.log("获取价签列表");
      this.priceTagOptions.priceTagList = [];
      console.log(this.priceTagOptions);
      const { templateName, templateSize, current, size } =
        this.priceTagOptions;
      const params = {
        templateName,
        templateSize,
        templateGroupId: "0", // 0：价签模板 1：营销模板
        openType: "0,1,2,3",
        current,
        size,
      };
      getTemplateList(params).then((res) => {
        console.log("priceTags", res.data.data);
        this.priceTagOptions.priceTagList = res.data.data.records.map((it) => {
          console.log(it.templateImageUrl);
          it.cover = it.templateImageUrl
            ? it.templateImageUrl.split(",")[this.getRandomInt(0, 4)]
            : "";
          return it;
        });
        this.priceTagOptions.total = res.data.data.total;
        console.log("priceTags,priceTagOptions", this.priceTagOptions);
      });
    },
    handlePriceTagCurrentChange(val) {
      // TODO
      console.log("handleImageCurrentChange", val);
      this.priceTagOptions.current = val;
      this.getPriceTagList();
    },
    handlePriceTagSizeChange(val) {
      // TODO
      console.log("handleImageSizeChange", val);
      this.priceTagOptions.current = 1;
      this.priceTagOptions.size = val;
      this.getPriceTagList();
    },

    handlePriceTagSearchChange(val) {
      console.log("handlePriceTagSearchChange", val);
      this.priceTagOptions.current = 1;
      this.priceTagOptions.templateName = val.templateName;
      this.priceTagOptions.templateSize = val.templateSize;
      this.getPriceTagList();
    },

    // 删除组件
    handleDeleteComponent({ component, index, confirmCallback }) {
      // 去除删除组件确认弹窗
      confirmCallback();
      return;
      this.$confirm("确认要删除选择的组件吗?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((_) => {
          confirmCallback();
        })
        .catch((_) => {});
    },

    handleBack() {
      // this.$router.go(-1);
      this.$confirm("确认已保存模板并关闭当前窗口?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          window.close();
        })
        .catch(() => {
          console.log("取消操作");
        });
    },

    getGoodsFields() {
      console.log(this.$route.query);
      console.log(this.$route.query.origin);
      const defaultScenario = this.userData.defaultScenarioId1;
      if (defaultScenario) {
        const params = {
          scenarioId: this.$route.query.scenarioId
            ? this.$route.query.scenarioId
            : defaultScenario,
        };
        // console.log('cnnnnnnnn',params)
        getScenario(params).then((res) => {
          const defaultScenario = res.data.data.fieldList;
          // console.log(defaultScenario)
          const goodsFields = defaultScenario.map((item) => {
            return {
              value: item.columnName,
              label: item.translateTextName,
              type: item.type,
            };
          });
          this.value.goodsFields = goodsFields;
          this.goodsFields = goodsFields;
        });
      } else {
        scenarioFiledList().then((res) => {
          const defaultScenario = JSON.parse(res.data.data.scenarioTemplate);
          const goodsFields = defaultScenario.map((item) => {
            return {
              value: "field_" + item.fieldId,
              label: item.translateTextName,
              type: item.type,
            };
          });
          this.value.goodsFields = goodsFields;
          this.goodsFields = goodsFields;
        });
      }
    },

    /**
     *
     * @param data 节目数据
     * @param blob 节目截图对象
     * @param callback 回调函数
     */
    handleSave(data) {
      console.log(data);

      // console.log(blob);
      // console.log(callback);
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      const params = {
        templateId: data.templateId,
        svgValue: JSON.stringify(data),
      };

      // console.log('=======')
      // console.log(JSON.parse(localStorage.getItem("templateInfo")))
      // console.log(data.pages)
      // return
      if (data.templateGroup == 3) {
        const EslParams = {
          templateId: data.templateId,
          svgStyle: "1",
          svgValue: JSON.stringify(data),
        };
        saveEslJson(EslParams).then((res) => {
          if (res.data.code == 1) {
            this.$message.success(this.$t("devices.saveSuccess"));
          } else {
            this.$message.error(res.data.message);
          }

          loading.close();
        });
        return;
      }

      saveJson(params).then((res) => {
        console.log(res);
        if (res.data.code == 1) {
          this.$message.success(this.$t("devices.saveSuccess"));
        } else {
          this.$message.error(res.data.message);
        }

        loading.close();
      });
      return;
      const saveOrUpdate = (cover) => {
        cover && (this.form.cover = cover);
        // 加版本号
        if (this.form.id) {
          data.kernelVersion = data.kernelVersion || "0.0.0";
          const versionList = data.kernelVersion.split(".");
          versionList[2] = parseInt(versionList[2]) + 1;
          data.kernelVersion = versionList.join("."); // 累加
        } else {
          data.kernelVersion = data.version;
        }
        console.log(data);
        this.form.layout = JSON.stringify(data);
        this.form.name = data.name;
        this.form.width = data.width;
        this.form.height = data.height;
        //console.log(this.form)
        return;
        const result = this.form.id
          ? editProgram(this.form)
          : addProgram(this.form);
        result
          .then(() => {
            this.$message.success("保存成功");
            this.$router.go(-1);
          })
          .catch((_) => {});
      };
      const formData = new FormData();
      formData.append("file", blob);
      return;
      uploadCover(formData)
        .then((res) => {
          const imgPath = res.data;
          saveOrUpdate(imgPath);
        })
        .catch((_) => {})
        .finally(() => {
          callback();
        });
    },

    // async getClipboardContent() {
    //   try {
    //     const clipboardText = await navigator.clipboard.readText();
    //     this.clipboardContent = clipboardText; // 处理并显示剪贴板内容
    //     console.log(this.clipboardContent)
    //   } catch (err) {
    //     console.error('Failed to read clipboard contents: ', err);
    //     this.clipboardContent = '无法读取剪贴板内容'; // 处理读取失败的情况
    //   }
    // },

    // 导入
    async handImport() {
      // console.log('initValue',this.clipboardContent)
      console.log("导入++++++！！！！！！！");
      // console.log(event)
      // console.log(navigator.clipboard.readText())
      // this.getClipboardContent()

      if (navigator.clipboard && navigator.clipboard.readText) {
        try {
          const clipboardText = await navigator.clipboard.readText();
          console.log(clipboardText);
          let firstChar = clipboardText.charAt(0);
          let lastChar = clipboardText.charAt(clipboardText.length - 1);
          console.log(typeof clipboardText);
          console.log(firstChar);
          console.log(lastChar);

          console.log(JSON.parse(clipboardText));
          if (firstChar == "[" && lastChar == "]") {
            console.log(this.value);
            this.impotFlag = this.impotFlag + 1;
            this.value.pages = JSON.parse(clipboardText);
            this.$message.success(this.$t("lcd.Editor.importSuccess"));
          } else {
            this.$message.error(this.$t("lcd.Editor.importRemind"));
          }
        } catch (err) {
          this.$message.error(this.$t("lcd.Editor.importError"));
          console.error("Failed to read clipboard contents: ", err);
          // this.clipboardContent = "无法读取剪贴板内容"; // 处理读取失败的情况
        }
      } else {
        this.$refs.importDialog.open();
        // const textArea = document.createElement("textarea");
        // textArea.style.position = "fixed"; // 避免滚动条跳动
        // // textArea.style.display = "none"; // 不显示
        // document.body.appendChild(textArea);
        // textArea.select();
        // document.execCommand("Paste");
      }
    },

    // 浏览器不兼容剪切板的兼容方法
    impotContent(val){
      console.log(val)
      this.impotFlag = this.impotFlag + 1;
      this.value.pages = JSON.parse(val);
    },

    // 导出-------废弃2025-09-24
    async handExport(data) {
      console.log(data);
      console.log("导出++++++！！！！！！！");
      if (navigator.clipboard && navigator.clipboard.writeText) {
      // if (false === 1) {
        navigator.clipboard.writeText(JSON.stringify(data.pages));
        this.$message.success(this.$t("lcd.Editor.exportSuccess"));
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = JSON.stringify(data.pages);
        textArea.style.position = "fixed"; // 避免滚动条跳动
        textArea.style.opacity = "0"; // 不显示
        document.body.appendChild(textArea);
        textArea.select();
        try {
          const success = document.execCommand("copy");
          // alert(success ? '复制成功！' : '复制失败！');
          console.log("success");
          console.log(success);
          this.$message.success(this.$t("lcd.Editor.exportSuccess"));
        } catch (err) {
          this.$message.error(this.$t("lcd.Editor.exportError"));
        } finally {
          document.body.removeChild(textArea);
        }
      }
    },

    createImg(obj) {
      console.log("cover img");
      return;
      createImg(obj.goodsId, obj.priceTagId).then((res) => {
        console.log("2134", obj.goodsId, obj.priceTagId);
        if (res.data) {
          this.$refs.editor.changePriceTagSrc(obj.componentId, res.data);
        }
      });
    },

    // 获取像素筛选项列表
    getPixelList() {
      getPixels().then((res) => {
        console.log(res);
        this.pixelsList = res.data.data;
      });
    },
    // 获取下拉枚举值
    async getEnum(id) {
      const params = {
        cateId: id,
      };
      try {
        const { data } = await getCodeList(params);
        if (data.state === true) {
          let arr = data.data || [];
          if (id == 40) {
            this.groupList = arr; // 素材分组list
          } else if (id == 41) {
            this.formatList = arr; // 图片格式类型list
          }
        } else {
          this.$message.error(data.message);
        }
      } catch (err) {
        const { message } = err;
        this.$message.error(message);
      }
    },
  },
};
</script>
<style lang="scss">
</style>
